module.exports = __webpack_public_path__ + "static/img/bg-banner-aboutus.8893d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-banner-aboutus.png
// module id = z1tV
// module chunks = 1